import Button from 'components/Button';
import Modal from 'components/Modal/Modal';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const MaxAppointmentsWarning = ({ isOpen, onClose }: TProps) => {
  return isOpen ? (
    <Modal title="Maximum Professionals Reached" onClose={onClose}>
      <p>
        You have reached the maximum number of professionals for a single
        appointment. Please update your selected services or book separate
        appointments.
      </p>
      <Button onClick={onClose}>Ok</Button>
    </Modal>
  ) : null;
};
